import { CdkScrollable } from '@angular/cdk/scrolling';
import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { EngineVersionData } from './engine-version-data';

@Component({
  selector: 'app-engine-about-dialog',
  templateUrl: './engine-about-dialog.component.html',
  styleUrls: ['./engine-about-dialog.component.scss'],
  imports: [CdkScrollable, MatDialogContent, MatDialogActions, MatButton, TranslatePipe],
})
export class EngineAboutDialogComponent {
  dialogRef = inject<MatDialogRef<EngineAboutDialogComponent>>(MatDialogRef);
  data = inject<EngineVersionData>(MAT_DIALOG_DATA);

  constructor() {}

  close(): void {
    this.dialogRef.close();
  }
}
